<template>
  <div>
    <cds-card>
      <div cds-layout="vertical gap:md">
        <h2 cds-text="section">Academic Procurement</h2>

        <cds-divider cds-card-remove-margin></cds-divider>

        <span>Sign up as...</span>

        <nav>
          <div cds-layout="horizontal gap:md align@md:right align@md:center" cds-text="body light">
              <router-link to="/student"><cds-button>Student</cds-button></router-link>
              <router-link to="/professor"><cds-button>Professor</cds-button></router-link>
              <router-link to="/admin"><cds-button>Admin</cds-button></router-link>
          </div>
        </nav>

        <p style="width:500px; word-wrap: break-word;">
          Requesting access for your entire class? Visit 
          <a :href="academicProcurementURL">
            <cds-button-inline>Control Center</cds-button-inline>
          </a>
          .
          <br><br>
          Lost your ID or password? Click 
          <a :href="forgotIDURL">
            <cds-button-inline>Here</cds-button-inline>
          </a>
          .
        </p>
      </div>
    </cds-card>
  </div>
</template>

<script>
import '@cds/core/alert/register.js';
import '@cds/core/card/register.js';
import '@cds/core/divider/register.js';
import '@cds/core/button/register.js';
import '@cds/core/button-inline/register.js';

export default {
  name: 'PersonDecider',
  data() {
    return {
      forgotIDURL: 'https://login.factset.com',
      academicProcurementURL: 'https://controlcenter.factset.com/orders-entitlements/academic-procurement'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
